import {createContext, useContext} from 'react';

const SsrDataPassContext = createContext(false);

export const SsrDataPassProvider = SsrDataPassContext.Provider;

export function useIsSsrDataPass(): boolean {
	return useContext(SsrDataPassContext);
}
